var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2537_376)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#112F4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2589 9.63547C25.5042 9.97036 24.6936 10.1968 23.8413 10.2985C24.7112 9.77765 25.3775 8.95228 25.6921 7.96995C24.8659 8.4607 23.9616 8.80618 23.0186 8.9914C22.2512 8.17342 21.1569 7.66272 19.9462 7.66272C17.6224 7.66272 15.7378 9.54659 15.7378 11.8718C15.7378 12.2012 15.7749 12.5226 15.8462 12.8312C12.348 12.6554 9.24662 10.9797 7.1707 8.43354C6.80821 9.0554 6.60073 9.77841 6.60073 10.5498C6.60073 12.0099 7.3439 13.2982 8.47314 14.0528C7.80465 14.0321 7.15083 13.8517 6.56634 13.5266V13.5798C6.56634 15.6193 8.01699 17.3199 9.94264 17.7067C9.5889 17.8036 9.21767 17.8543 8.83361 17.8543C8.56207 17.8543 8.29863 17.8286 8.04127 17.7802C8.5769 19.4518 10.1314 20.6686 11.9727 20.703C10.5322 21.8323 8.71702 22.5054 6.74557 22.5054C6.40601 22.5054 6.07042 22.4851 5.74097 22.4454C7.60398 23.64 9.81599 24.3374 12.1931 24.3374C19.9348 24.3374 24.1688 17.9237 24.1688 12.3617C24.1688 12.1791 24.1648 11.9978 24.156 11.8172C24.9809 11.2206 25.693 10.4818 26.2589 9.63547Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2537_376"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.4e930d34ac5f816f8139ffd606037387.svg";
export { ForwardRef as ReactComponent };